import isItemView from 'owa-mail-store/lib/utils/isItemView';

class EmailContextViewState {
    private isItemViewNeeded = false;

    private renderInConversationView = false;

    public setIsItemViewNeeded(value) {
        this.isItemViewNeeded = value;
    }

    public setRenderInConversationView(value) {
        this.renderInConversationView = value;
    }

    public shouldItemViewBeShown() {
        return this.isItemViewNeeded || (isItemView() && !this.renderInConversationView);
    }

    public resetValues() {
        this.setIsItemViewNeeded(false);
        this.setRenderInConversationView(false);
    }
}

const ECViewState = new EmailContextViewState();

export default ECViewState;
